const Routes = {
    HOME: '/',
    AUTH: '/',
    ST_PORTAL: '/st-portal',
    AUTH_LOGIN: '/auth/login',
    AUTH_SIGNIN: '/auth/signup',
    AUTH_REFERRAL: '/auth/referral',
    AUTH_MAIL: '/auth/mail',
    AUTH_RESET_PASSWORD: '/auth/reset-password',
    CHECKMAIL: '/auth/email-verification',
    HOMEVIEW: '/home',
    CREATE_GROUP_PROCESS: "/process/createGroup",
    CREATE_MY_COMPANY: "/company/create",
    COMPANY_ONBOARDING: "/company/onboarding",
    COMPANY_OUTLOOK_PROMO: "/company/outlook-promo",
    CONTACTUS: '/contact',
    COMAPNYINVITED: '/company/invited',
    COMPANYANALYSIS: '/company/analysis',
    REFERRAL: "/company/referral-survey",
    PROCESS_CREATE: '/process/create',
    PROCESS_BY_FOLDER: '/process/folder/',
    PROCESS_INTERVIEW: '/process/interviews/',
    PROCESS_VIEW: '/process/overview',

    // COLLECT DATA
    DATA_COLLECT: '/process/data-collect/create',

    MY_PROCESS: '/process/my/processes',
    ALL_GROUP: '/process/folder',
    ALL_MAP: '/process/all',
    PROCESSLIBRARY: '/process/library',
    ANALYSIS: '/process/analysis',
    MAPPING: '/process/mapping/',
    PRIVACY: '/Privacy_Policy',
    FAQ: '/faq',
    TERMS: "/terms_and_conditions",

    CAMPAIGNS: '/campaigns',
    PRICING: '/pricing',

    // PAYMENT ROUTES
    PAYMENT_SUCCESS: '/payment-success',
    PAYMENT_CANCEL: '/payment-cancel',


    //dASHBOAD
    USERS_LIST: "/dashboard/users",
    COLLABORATORS_LIST: "/dashboard/collaborators",
    USERS_DETAILS: "",
    DASHBOARDS: '/dashboard/home',
    OWNER_LIST: "/dashboard/owner",
    ADMIN_LIST: "/dashboard/admin",
    PROCESS_LIST: "/dashboard/process",
    ANDON_HUB: "/dashboard/andon",
    MICROSOFT_INTEGRATIONS: "/dashboard/microsoft-integrations",
}

export default Routes